"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardTrafficShipment = _interopRequireDefault(require("./CardTrafficShipment"));

var _Header = _interopRequireDefault(require("./Header"));

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TrafficShipmentRowDetail = function TrafficShipmentRowDetail(_ref) {
  var headerTitle = _ref.headerTitle,
      headerIcon = _ref.headerIcon,
      trips = _ref.trips,
      shipments = _ref.shipments;
  return /*#__PURE__*/_react["default"].createElement(_styles.Container, null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    headerTitle: headerTitle,
    headerIcon: headerIcon,
    trips: trips
  }), /*#__PURE__*/_react["default"].createElement(_CardTrafficShipment["default"], {
    shipments: shipments
  }));
};

TrafficShipmentRowDetail.propTypes = {
  headerIcon: _propTypes["default"].any,
  headerTitle: _propTypes["default"].string,
  trips: _propTypes["default"].array,
  shipments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    details: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      type: _propTypes["default"].string,
      begin: _propTypes["default"].instanceOf(Date),
      end: _propTypes["default"].instanceOf(Date),
      color: _propTypes["default"].string,
      icon: _propTypes["default"].any,
      events: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        showAt: _propTypes["default"].instanceOf(Date),
        data: _propTypes["default"].any
      }))
    }))
  }))
};
TrafficShipmentRowDetail.defaultProps = {
  headerIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
  headerTitle: 'TZ-380',
  trips: ['item-1', 'item-2'],
  shipments: [{
    details: [{
      type: 'STAY',
      begin: new Date(2021, 4, 5, 3, 24, 0),
      end: new Date(2021, 4, 10, 3, 24, 0),
      color: '#365c80',
      icon: '🚛',
      events: [{
        showAt: new Date(2021, 4, 7, 3, 24, 0),
        data: ''
      }]
    }]
  }]
};
var _default = TrafficShipmentRowDetail;
exports["default"] = _default;